import Vue from 'vue';
import PageContainer from './PageContainer.vue';

Vue.component('page-container', PageContainer);